module.exports = __webpack_public_path__ + "static/visualOn-9089643cfe19e5bcd31bfb9bb0517196.png";